<template>
    <div class="code-generator-page">
        <div class="container">
            <h1>Code generator page</h1>
            <!-- <p>asdasdas{{ codeItems }}</p> -->
            <input type="file" @change="handleFileChange" accept=".txt">

            <br><br><br>
            <button @click="codeGeneratorInit">Сгенерировать коды</button><br><br>
            <!-- {{ codeItemsGen }} -->
            <hr>
            <a href="#" @click.prevent="getCount">Получить размер</a>
            <hr>
            <br><br><br>
            <hr>
            <a href="#" @click.prevent="updateUsers">DATA USERS UPDATE</a>
            <hr>
            <!-- <ul>
                <li v-for="item in codeItems">{{ item }}</li>
            </ul> -->
        </div>
    </div>
</template>

<script>
    // import {mapGetters} from 'vuex'
    // import svgIcon from '@/components/partials/SvgIcon.vue'
    import { writeBatch, collection, doc, setDoc, getCountFromServer, query, where,  getDoc, getDocs, updateDoc, arrayUnion } from "firebase/firestore"; 

    const crypto = require('crypto');
    export default {
        name: 'code-generator-page',
        components: {
            // svgIcon,
        },
        data () {
            return {
                // codes: require('@/assets/codes.txt'),
                codeItems: null,
                codeItemsGen: null,
            }
        },
        methods: {
            codeGeneratorInit() {
                const encryptionKey = 'vweb_Confirm@';
                const characters = 'ABCDEFGHJKLMNPRSTUVWXYZ23456789'; // Исключены буквы O, I, B, L
                const quantity = 1000;
                const codeLength = 8;
                const generatedCodes = new Set();

                function encryptAndTrim(code) {
                    // Пример использования SHA-256 для хэширования
                    const hash = crypto.createHash('sha256').update(encryptionKey + code).digest('hex');
                    return hash.slice(0, codeLength).toUpperCase(); // Обрезаем до 8 символов
                }

                while (generatedCodes.size < quantity) {
                    let code = '';
                    for (let i = 0; i < codeLength; i++) {
                        const randomIndex = Math.floor(Math.random() * characters.length);
                        code += characters.charAt(randomIndex);
                    }

                    const encryptedAndTrimmedCode = encryptAndTrim(code);

                    // Проверка на уникальность
                    if (!generatedCodes.has(encryptedAndTrimmedCode)) {
                        generatedCodes.add(encryptedAndTrimmedCode);
                    }
                }


                this.codeItemsGen = Array.from(generatedCodes);
                const outputText = this.codeItemsGen.join('\n');
                  // Создаем объект Blob
                const blob = new Blob([outputText], { type: 'text/plain' });

                // Создаем ссылку на Blob
                const url = window.URL.createObjectURL(blob);

                // Создаем ссылку для скачивания файла
                const link = document.createElement('a');
                link.href = url;
                link.download = 'output.txt';

                // Добавляем ссылку на страницу и автоматически нажимаем на нее
                document.body.appendChild(link);
                link.click();

                // Удаляем ссылку
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                console.log(this.codeItemsGen)

            },
            handleFileChange(event) {
                const file = event.target.files[0];
                const reader = new FileReader();
                const _self = this;

                reader.onload = function() {
                    const fileContent = reader.result;

                    // Разбиваем содержимое файла на строки
                    const lines = fileContent.split('\n').map(line => line.trim());
                    const jsonArray = lines.map(code => ({
                        code,
                        activate: false, 
                        win_status: false
                    }));

                    // Разбиваем массив jsonArray на пакеты по batchSize
                    const batchSize = 100; // Измените размер пакета по своему усмотрению
                    const batches = [];
                    for (let i = 0; i < jsonArray.length; i += batchSize) {
                        batches.push(jsonArray.slice(i, i + batchSize));
                    }

                    // Добавляем коды в коллекцию Firestore пакетами
                    batches.forEach(batch => {
                        _self.addCodesToDB(batch);
                    });
                };

                reader.readAsText(file);
            },

            async addCodesToDB(batch) {
                const batchRef = writeBatch(this.$db);

                batch.forEach(codeData => {
                    const docRef = doc(collection(this.$db, 'codes'), codeData.code); // Получаем ссылку на документ
                    batchRef.set(docRef, codeData); // Добавляем документ в пакетную операцию записи
                });

                // Коммитим пакетную операцию записи
                await batchRef.commit();
                console.log('Пакетная операция записи успешно завершена.');
            },

            async getCount() {
                var codesArrLength = [];
                const codesActive = query(collection(this.$db, "codes"), where("activate", "==", false));
                const snapshotCodes = await getCountFromServer(codesActive);

                codesArrLength = snapshotCodes.data().count;
                console.log(codesArrLength)
            },
            async updateUsers() {
                const usersList = [];
                const q = query(collection(this.$db, "users"), where("user.online_test", "==", false));
                const querySnapshot = await getDocs(q);
                querySnapshot.forEach((doc) => {
                // doc.data() is never undefined for query doc snapshots
                    if (doc.data().codes == null) {
                        // console.log(doc.id, " => ", doc.data());
                        usersList.push(doc.data());
                    }
                });
                // const filteredData = usersList.filter(item => {
                //     // Если у объекта есть свойство 'codes' и его длина больше или равна 1, то оставляем этот объект
                //     return !item.hasOwnProperty('codes') || (Array.isArray(item.codes) && item.codes.length >= 1);
                // });

                // for (var i =0; i < usersList.length; i++) {
                //     const userRef = doc(this.$db, "users", usersList[i].user.ID);
                //     await updateDoc(userRef, {
                //         'user.online_test' : true,
                //         'user.online_test_invite' : true,
                //     });
                // }
                console.log(usersList);
            },
            // handleFileChange(event) {
            //     const file = event.target.files[0];
            //     const reader = new FileReader();
            //     var _self = this;

            //     reader.onload = function() {
            //         const fileContent = reader.result;

            //         // Разбиваем содержимое файла на строки
            //         const lines = fileContent.split('\n').map(line => line.trim());
            //         const jsonArray = lines.map(code => ({
            //             code,
            //             activate: false, 
            //             win_status: false
            //         }));
            //         // const lines = fileContent.split('\n').filter(Boolean);
            //         _self.codeItems = jsonArray.slice(0, 10000);

            //         // Преобразуем строки в объект JSON
            //         // this.codeItems = lines;
            //         console.log(_self.codeItems );
            //         _self.addCodesTOdb();
            //     };

            //     reader.readAsText(file);
            // },
            // async addCodesTOdb() {
            //     console.log(this.codeItems, 'test')
            //     const batch = writeBatch(this.$db);
            //     this.codeItems.forEach(data => {
            //         // console.log(data, 'FOREACH')
            //         const newCode = doc(this.$db, "codes", data.code);
            //         batch.set(newCode, data);
            //     });
            //     await batch.commit();
            // }
        },
        beforeCreate() {
            document.body.dataset.page = 'code-generator-page';
        },
        created () {
            // this.getCodes();
            // this.codeGeneratorInit();
        },
        mounted() {
        }
    }
</script>


<style lang="scss">
    .code-generator-page {
        padding-top: 50px;
    }
    h1 {
        margin-bottom: 50px;
    }
</style>